import { createFileRoute } from '@tanstack/react-router'
import { BlockedCategoriesPage } from '@features/admin/blocked-categories'

export const Route = createFileRoute('/admin/blocked-categories')({
  component: RouteComponent,
})

function RouteComponent() {
  return <BlockedCategoriesPage />
}
